import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsBannerComponent } from '@spartacus/core';
import { CmsComponentData, GenericLinkComponent, MediaComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-banner',
    templateUrl: './kn-br-banner.component.html',
    styleUrls: ['./kn-br-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GenericLinkComponent, MediaComponent, AsyncPipe]
})
export class KnBrBannerComponent implements OnInit {
  componentData$: Observable<CmsBannerComponent> = this.componentData.data$;
  constructor(protected componentData: CmsComponentData<CmsBannerComponent>) {}
  ngOnInit(): void {}
}
